import { render } from "./AddFacultyLoadingDialog.vue?vue&type=template&id=15be094a"
import script from "./AddFacultyLoadingDialog.vue?vue&type=script&lang=js"
export * from "./AddFacultyLoadingDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__